<template>
    <div>
        <breadCrumb 
            :icon="'fa-users'"
            :category="$t(`sideNav.navMySalon`)"
            :subCategory="$t(`subMenu.my_salon_member`)"
            :subSubCategory="''">
        </breadCrumb>
        <div v-if="!addToggle" class="text-right mt-3 mr-5">
            <button class="btn buttons-csv buttons-html5 btn-outline-primary" type="button" title="Add New Member" @click="addToggle = !addToggle">
                <span class="fal fa-plus mr-2"></span>
                <span>{{$t('button_link.add')}}{{$t(`subMenu.my_salon_member`)}}</span>
            </button>
        </div>
        <div v-if="!addToggle">
            <ul  class="nav nav-tabs nav-tabs-clean px-3 px-sm-5 mt-3" role="tablist">
                <li class="nav-item" v-for="t in $i18n.messages[$i18n.locale].tab.memberTabLists" :key="t.id">
                    <a class="nav-link bg-transparent fs-lg fw-400" :class="{'active': selectedTab == t.id}" @click="selectedTab = t.id">{{t.text}}</a>
                </li>
            </ul>
            <div class="px-3 px-sm-5 py-4">
                <div class="tab-content mt-5">
                    <memberList ref="memberList" :class="{'active': selectedTab == 'active' || selectedTab == 'hidden' || selectedTab == 'delete' }" class="tab-pane"></memberList>
                    <memberChangeMobile  :class="{'active': selectedTab == 'changeMobile' }" class="tab-pane"></memberChangeMobile>
                    <!-- <memberDelete :class="{'active': selectedTab == 'delete' }" class="tab-pane"></memberDelete> -->
                </div>
            </div>
        </div>
        <div v-else class="px-3 px-sm-5 py-4">
            <div class="panel mb-0">
                <div class="panel-hdr">
                    <h2>{{$t('header.add')}}{{$t(`subMenu.my_salon_member`)}}</h2>
                </div>
                <div class="panel-container">
                    <div class="panel-content">
                        <memberForm @returnMemberList="returnMemberList"></memberForm>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import BreadCrumb from './../../Bread_Crumb'
import MemberForm from './Member_Form'
import MemberList from './Member_List'
import MemberChangeMobile from './Member_ChangeMobile'
import MemberDelete from './Member_Delete'
export default {
    name: 'member',
    components:{
        BreadCrumb,
        MemberForm, 
        MemberList, 
        MemberChangeMobile,
        // MemberDelete,
    },
    data(){
        let selectedtab = this.$i18n.messages[this.$i18n.locale].tab.memberTabLists[0].id
        return{
            addToggle: false,
            selectedTab: selectedtab,
            memberLists: [], outlet:[]
        }
    },
    watch:{
        selectedTab(value){
            if(value == "active" || value == "hidden" || value == "delete"){
                this.$refs.memberList.filterMemberByView(value);
            }
        },
    },
    methods:{
        returnMemberList(){
            this.addToggle = false;
        },
    },
}
</script>